import React, { Component } from "react";
import { Row, Col, Button, Modal, Typography, Form, Statistic, Tag, message, Spin, Divider, Space, Select } from 'antd';

//componentes
import { PaperClipOutlined } from "@ant-design/icons";
import AvatarProductos from '../../../Widgets/AvatarProductos';
import { RenderMoney, RenderSolicitudCompra } from "../../../Utils.js"

const { Title, Text } = Typography;
const axios = require('axios').default;
const moment = require('moment');



/**
 *
 *
 * @class ModalSolicitudDetalle
 * @extends {Component}
 */
class ModalSolicitudDetalle extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            solicitud: null
        }

    }

    formRef = React.createRef();

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        if(this.props.solicitud_id){
        	this.getSolicitud()
        }
    }


    /**
    * @memberof ModalTran
    * @method getSolicitud
    * @description Obtiene la informacion de la solicitud para el modal de detalle.
    */
    getSolicitud = (id) => {
        this.setState({ loading: true })
        axios.get('/customer/solicitud/' + this.props.solicitud_id)
        .then(({ data }) => {
            this.setState({ solicitud: data });
            this.formRef.current.setFieldsValue({
                estado_aprobacion: data.estado_aprobacion
            });
        })
        .catch(error => {
            console.log('error', error.response)
            message.error("Error al obtener la información de la solicitud")
        })
        .finally(() => {
            this.setState({ loading: false })
        })

    }


    /** * @memberof ModalSolicitudDetalle
     * @method submit
     * @description Envía los cambios realizados en la solicitud
     */
    submit = (values) => {
        this.setState({ loading: true });
        axios.put('/customer/solicitud/update/' + this.props.solicitud_id, values)
            .then(({ data }) => {
                message.success("Solicitud actualizada correctamente");

                if(data?.estado_aprobacion === 1) {
                    message.info("Solicitud aprobada, creando orden de compra...");
                    this.createOrder(data);
                } else {
                    this.props.onClose();
                }

            })
            .catch(error => {
                console.log('error', error);
                message.error(error?.response?.data?.message || "Error al actualizar la solicitud");
                this.setState({ loading: false });
            })
            
    }

    
    /**
     * @memberof ModalCompraProductos
     * @method createOrder
     * @description Si la solicitud de compra es aprobada, crea una orden de compra
     */
    createOrder = (values) => {
        this.setState({ loading: true });
        axios.post('/vmi/orden/add', {
            ...values
        }).then(response => {
            message.success('Compra Creada')
            this.props.onClose()
        }).catch(error => {
            if (error.response.status === 402){
                Modal.error({
                    title: error.response.data.title || 'Error al crear la orden',
                    content: error.response.data.message || 'Vuelva a verificar sus datos',
                });
                this.props.onClose()
            }else
                message.error(error.response.data.message || 'Error al crear la orden')
        }).finally(() => this.setState({ loading: false }))


    }

    render() {
        const { solicitud } = this.state;

        return (
            <Form layout="vertical"   onFinish={this.submit} ref={this.formRef}>
                <Title level={3} className="text-center">Detalle Solicitud </Title>
                <Spin spinning={this.state.loading}>
                    <Row justify="center" gutter={[24,8]} className="mb-3">
                        <Col xs={24} lg={11}>
                            <Space.Compact direction="vertical">
                                <Text className="text-gray"> ESTADO </Text>
                                {RenderSolicitudCompra(solicitud)}
                            </Space.Compact>
                        </Col>
                        <Col xs={24} lg={11} className="flex-right">
                        	<Space.Compact direction="vertical"> 
                                <Text className="text-gray"> FECHA DE SOLICITUD </Text>
                                <Text> {moment(solicitud?.createdAt).format('LL')} </Text>
                            </Space.Compact>
                        </Col>
                        <Col xs={22}  lg={11} className="mt-1">
                        	<Space.Compact direction="vertical"> 
                                <Text className="text-gray"> USUARIO SOLICITANTE </Text>
                                <strong> {solicitud?.usuario_solicitante_id?.nombre_completo} </strong>
                            </Space.Compact>
                        </Col>
                        <Col xs={24} lg={11} className="mt-1">
                        	<Space.Compact direction="vertical"> 
                                <Text className="text-gray"> CENTRO DE COSTO </Text>
                                <Text> {solicitud?.centro_costo_id?.nombre} {solicitud?.centro_costo_id?.limite ? `- LIMITE: $ ${solicitud?.centro_costo_id?.limite?.toMoney(true)} MXN` : ''} </Text>
                                <Text type="secondary">Encargado(s):  {solicitud?.centro_costo_id?.usuarios?.map(usuario => usuario.nombre_completo).join(', ')}</Text>
                            </Space.Compact>
                        </Col>
                        <Col xs={22} className="">
                        	<Space.Compact direction="vertical"> 
                                <Text className="text-gray"> ALMACÉN </Text>
                                <Text> {solicitud?.almacen_id?.direccion} </Text>
                            </Space.Compact>
                        </Col>
                        { solicitud?.usuario_aprobador_id?.nombre_completo ? <Col xs={22} className=" mt-1 mb-1">
                        	<Space.Compact direction="vertical"> 
                                <Text strong> MODIFICADO POR: </Text>
                                <Text> {solicitud?.usuario_aprobador_id?.nombre_completo} </Text>
                            </Space.Compact>
                        </Col> : null }
                        <Col xs={22}>
                        	
                            <Text strong className="text-gray mt-2 mb-1"> PRODUCTO </Text>

                                <Row className="width-100" gutter={[8,8]}>
                                    
                                    <Col className="">
                                        <AvatarProductos imagenes={solicitud?.producto_id?.imagenes} size={94}/>
                                    </Col>
                                    <Col span={14} flex="auto" className="">
                                        <Space.Compact direction="vertical">
                                            <Text>{solicitud?.producto_id?.descripcion}</Text>
                                            <small>{solicitud?.producto_id?.marca} - {solicitud?.inventario_producto_id?.np_cliente}</small>
                                            <Text>Cantidad: {solicitud?.cantidad_solicitada}</Text>
                                            <RenderMoney monto={solicitud?.inventario_producto_id?.precio}/>
                                        </Space.Compact>
                                    </Col>
                                </Row>

                            
                        </Col>
                        <Col span={16} className="flex-right">
                            <Text strong className="text-gray">TOTAL DE COMPRA: </Text>
                        </Col>
                        <Col span={6} className="flex-right">
                        	<RenderMoney monto={solicitud?.total_compra} valueStyle={{fontWidth: "Bold", fontSize: "18px"}}/>
                        </Col>
                        <Col span={22} className="mt-2">
                            <Form.Item label="CAMBIAR ESTADO DE SOLICITUD" name="estado_aprobacion" rules={[{ required: true, message: 'Por favor selecciona un estado' }]}>
                                <Select
                                    placeholder="Selecciona un estado"
                                    options={[
                                        { label: 'Aprobado', value: 1 },
                                        { label: 'Rechazado', value: 2 },
                                        { label: 'Cancelado', value: 3 }
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={5} className="center">
                            <Button type="primary" htmlType="submit" className="btn-primary">
                                Guardar Cambios
                            </Button>
                        </Col>
                    </Row>
                </Spin>
            </Form>
        )
    }
}



export default function (props) {
    const { visible = false, onClose = () => { } } = props

    return <Modal
        visible={visible}
        onCancel={onClose}
        title={null}
        footer={null}
        closable={true}
        destroyOnClose={true}
        zIndex={1000}
        width={800}
    >
        <ModalSolicitudDetalle {...props} />
    </Modal>

}